<template>
  <div class="thumbnail-container d-flex justify-center">
    <vertical-premium-ribbon v-if="requiredSubscriptionPlans.length" :related-subscription-plan="requiredSubscriptionPlans[0]" />
    <user-profile-link v-if="!postHasMedia" :user-id="post.author.id">
      <user-avatar :user="post.author" :size="size" />
    </user-profile-link>
    <post-media v-else :post="post" disabled compact changing-image-measurements-delayed />
  </div>
</template>

<script>
import PostMedia from "@/components/postables/PostMedia.vue"
import VerticalPremiumRibbon from "@/components/premium/VerticalPremiumRibbon.vue"

import * as authorization from "@/services/authorization.js"

import { paywallSourceTypes } from "@/constants/paywall.js"

export default {
  components: {
    PostMedia,
    VerticalPremiumRibbon
  },
  props: {
    post: {
      type: Object,
      required: true
    },
    size: {
      type: Number,
      default: 56
    }
  },
  computed: {
    sizePx() {
      return `${this.size}px`
    },
    requiredSubscriptionPlans() {
      return authorization.getRequiredSubscriptionPlans(this.post, {
        sourceType: paywallSourceTypes.POST,
        sourceId: this.post.id
      })
    },
    postHasMedia() {
      //Remove attachments? check when backend is fixed, here and in the template
      return this.post.images.length || this.post.gifs.length || this.post.videos.length || this.post.attachments?.length
    }
  }
}
</script>

<style lang="scss" scoped>
$media-size: v-bind(sizePx);

.thumbnail-container {
  position: relative;
  width: $media-size !important;
  height: $media-size;
}

:deep(.post-media-container) {
  height: $media-size !important;
  width: $media-size !important;
  border-radius: var(--rounded-app);

  .image-viewer-item-container,
  .video-player-container,
  .jw-flag-aspect-mode,
  .v-img,
  .document-container,
  video {
    height: $media-size !important;
    width: $media-size !important;
    justify-content: center;
  }
}
</style>
